export const PARTNER_CATEGORIES = [
  { value: "avocat", label: "Avocat", price: 150.99, desc: "Conseil et accompagnement juridique des étrangers (bénévole ou rémunéré)." },
  { value: "association", label: "Association", price: 0, desc: "Accompagnement social, cours de français, aide aux démarches." },
  { value: "centre_formation", label: "Centre de formation & examen civique", price: 80.99, desc: "Formations civiques et linguistiques, sessions d'examen agréées." },
  { value: "offre_emploi", label: "Offre d'emploi / Recruteur", price: 80.99, desc: "Publiez vos offres et recrutez des talents nouvellement arrivés." },
];

export const RESOURCE_TYPES = [
  { value: "contact", label: "Contact" },
  { value: "tarif", label: "Tarifs" },
  { value: "benevolat", label: "Bénévolat" },
  { value: "service", label: "Service proposé" },
  { value: "information", label: "Information" },
];

export const priceFor = (category, isNonprofit) => {
  const c = PARTNER_CATEGORIES.find((x) => x.value === category);
  if (!c) return 0;
  return isNonprofit ? 0 : c.price;
};

export const priceLabel = (amount) =>
  amount === 0 ? "Gratuit" : `${amount.toFixed(2).replace(".", ",")} €/mois`;

export const categoryLabel = (value) =>
  PARTNER_CATEGORIES.find((x) => x.value === value)?.label || value;
